export const TABLE_SORT_PARAM = 'sort'
export const TABLE_ORDER_PARAM = 'order'
